import React from 'react';

import styles from './Experience.module.scss';

const Experience = (props) => (
  <div className={styles.Experience} id={props.identifier}>
    <div className={styles.Experience__Wrapper}>
      <div className={styles.Experience__Title}>
        <h2>Your Experience</h2>
      </div>
      <h3>{props.title}</h3>
      <p>{props.text}</p>
      <img src={props.featuredImage.file.url} alt={props.featuredImage.title} />
    </div>
  </div>
)

export default Experience;



// WEBPACK FOOTER //
// ./src/components/Destination/Experience/index.js